import {Rule} from "antd/es/form";
import {Dayjs} from "dayjs";
import {CommonFormMessages} from "../../../intl/commonMessages/CommonFormMessages";
import {IntlShape} from "react-intl";

/**
 * Возвращает правила валидации для DateAndTimePicker
 * @param intl - объект для интернационализации
 * @param requireTime - требуется ли заполнение времени (по умолчанию true)
 * @returns массив правил валидации
 */
export const getDateAndTimePickerValidationRules = (
  intl: IntlShape,
  requireTime: boolean = true
): Rule[] => {
  const rules: Rule[] = [
    {
      required: true,
      message: intl.formatMessage(CommonFormMessages.ruleRequired)
    }
  ];

  if (requireTime) {
    rules.push({
      validator: (_, value: Dayjs | null) => {
        // Если значение не установлено, пропускаем валидацию (required правило обработает это)
        if (!value) {
          return Promise.resolve();
        }
        // Проверяем, что value является Dayjs объектом (имеет метод format)
        if (typeof value.format !== 'function') {
          // Если value не Dayjs объект, пропускаем валидацию (значение еще не готово)
          return Promise.resolve();
        }
        
        // Проверяем, что время заполнено и валидно
        // Время должно быть в формате HH:mm от 00:00 до 23:59
        const timeString = value.format('HH:mm');
        const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
        const isTimeValid = timeRegex.test(timeString);
        
        if (!isTimeValid) {
          // Время невалидно (пустое или неполное)
          return Promise.reject(new Error(intl.formatMessage(CommonFormMessages.ruleTimeRequired)));
        }
        
        // Проверяем, что время находится в допустимом диапазоне (00:00 - 23:59)
        const [hours, minutes] = timeString.split(':').map(Number);
        if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
          return Promise.reject(new Error(intl.formatMessage(CommonFormMessages.ruleTimeRequired)));
        }
        
        // 00:00 - валидное время, разрешаем его
        // Если время было введено в поле (даже если это 00:00), это валидное время
        return Promise.resolve();
      }
    });
  }

  return rules;
};

